// Guest session: persists the visitor's name + role across visits.
// role: "guest" | "admin" | null
const KEY = "wedding_guest_session";
const LEGACY_KEY = "wedding_guest_name";

export function getGuestSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {/* ignore */}
  return null;
}

export function setGuestSession(session) {
  try {
    localStorage.setItem(KEY, JSON.stringify(session));
  } catch {/* ignore */}
}

export function clearGuestSession() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(LEGACY_KEY);
  } catch {/* ignore */}
}

// Convenience: read the saved guest name (used by RSVP/Message/Gallery forms)
export function getGuestName() {
  const s = getGuestSession();
  if (s?.name) return s.name;
  try {
    return localStorage.getItem(LEGACY_KEY) || "";
  } catch { return ""; }
}

// Update only the name (e.g. when admin types another author for guest upload).
export function setGuestName(name) {
  const v = (name || "").trim();
  if (!v) return;
  const s = getGuestSession() || { role: "guest", name: v };
  setGuestSession({ ...s, name: v });
}
